import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../services/user/models/user.model';
import { UserService } from '../../services/user/user.service';

@Pipe({ name: 'userCurrency' })
export class UserCurrencyPipe implements PipeTransform {
  constructor(private userService: UserService) {
  }

  public transform(user: User): string {
    if (!user) {
      return 'USD';
    }

    switch (true) {
      case this.userService.isEURUser(user.CountryCode):
        return 'EUR';
      case this.userService.isGBUser(user):
        return 'GBP';
      default:
        return 'USD';
    }
  }
}
